import LN_LOGO from '../../../assets/images/lN_LOGO.png'
import '../BrandLogos.scss'

const LeadershipNetLogo = ({ href = '/' }) => {
  return (
    <a href={href} className="brandLogo brandLogo--ln" aria-label="leadership.NET">
      <span className="brandLogo__badge" aria-hidden="true">
        <img
          className="brandLogo__img brandLogo__img--ln"
          src={LN_LOGO}
          alt=""
          width="512"
          height="512"
          decoding="async"
        />
      </span>

      <span className="brandLogo__lockup">
        <span className="brandLogo__lnText">
          <span className="brandLogo__lnLeadership">leadership</span>
          <span className="brandLogo__lnDot">.</span>
          <span className="brandLogo__lnNet">NET</span>
        </span>
      </span>
    </a>
  )
}

export default LeadershipNetLogo
